module.exports = [
  {
    position: 'DA',
    specialty: 'General',
    display: 'Dental Assistant',
    url: 'dental-assistant',
    synonyms:
      'DA,RDA,Registered Dental Assistant,Certified Dental Assistant,Dental Hygienist Assistant,Dental Office Assistant,Sterilization Assistant,Chairside Dental Assistant',
    searchterms:
      'DA, RDA, Registered, Assistant, Certified, Sterilization, Chair, Chairside',
  },
  {
    position: 'FO',
    specialty: 'Billing',
    display: 'Dental Billing',
    url: 'dental-billing',
    searchterms: '',
  },
  {
    position: 'FO',
    specialty: 'General',
    display: 'Dental Front Office',
    url: 'dental-front-office',
    synonyms:
      'Front Office Staff,Front Office Manager,Front Office Assistant,Dental Back Office,Operations Manager,Administrative Assistant',
    searchterms:
      'Front, Office, Staff, Manager, Back, Operations, Administrative',
  },
  {
    position: 'DH',
    specialty: 'General',
    display: 'Dental Hygienist',
    url: 'dental-hygienist',
    synonyms:
      'DH, RDH, Registered Dental Hygienist, Dental Hygiene,Oral Hygienist',
    searchterms: 'DH, RDH, Registered, Hygienist, Hygiene, Hyg, Oral',
  },
  {
    position: 'FO',
    specialty: 'Insurance',
    display: 'Dental Insurance',
    url: 'dental-insurance',
    searchterms: '',
  },
  {
    position: 'LT',
    specialty: 'General',
    display: 'Dental Laboratory',
    url: 'dental-lab-tech',
    synonyms:
      'Lab Technician,Medical Laboratory Technician,Medical Lab Tech,Clinical Laboratory Technician,Dental Laboratory Technician,Dental Lab Tech,Denture Technician,Dental Prosthesis Technician,Certified Dental Technician',
    searchterms:
      'Lab, Technician, Medical, Laboratory, Tech, Clinical, Lab Tech, Denture, Prosthesis',
  },
  {
    position: 'FO',
    specialty: 'Office Manager',
    display: 'Dental Office Manager',
    url: 'dental-office-manager',
    synonyms:
      'Office Manager,Dental Front Office Manager,Dental Manager,Dental Office Coordinator,Dental Supervisor,Dental Department Manager',
    searchterms: 'Office, Manager, Coordinator, Supervisor, Department',
  },
  {
    position: 'FO',
    specialty: 'Reception',
    display: 'Dental Receptionist',
    url: 'dental-receptionist',
    synonyms: 'Dental Office Receptionist,Dental Front Desk Receptionist',
    searchterms: 'Reception, Desk',
  },
  {
    position: 'SR',
    specialty: 'General',
    display: 'Dental Sales',
    url: 'dental-rep',
    synonyms:
      'Dental Sales Representative,Business Development Representative,Medical Sales Representative,Field Sales Representative,Technical Sales Representative,Outbound Sales Representative,Inbound Sales Representative',
    searchterms:
      'Sales, Representative, Business, Development, Medical, Field, Technical, Outbound, Inbound',
  },
  {
    position: 'DD',
    specialty: 'General',
    display: 'Dentist',
    url: 'dentist',
    synonyms:
      "Family Dentist,Children's Dentist,Emergency Dentist,General Dentist,Teledentistry,Specialist Dentist,Aesthetic Dentist,Biological Dentist",
    searchterms:
      'Family, Children, Emergency, General, Tele, Teledentistry, Specialist, Aesthetic, Biological',
  },
  {
    position: 'FO',
    specialty: 'Endodontic',
    display: 'Endodontic Dental Front Office',
    url: 'endodontic-dental-front-office',
    synonyms: '',
    searchterms: 'endo',
  },
  {
    position: 'DD',
    specialty: 'Endodontic',
    display: 'Endodontist',
    url: 'endodontist',
    synonyms: '',
    searchterms: 'endo',
  },
  {
    position: 'DD',
    specialty: 'Surgical',
    display: 'Oral Surgeon',
    url: 'oral-surgeon',
    synonyms: '',
    searchterms: '',
  },
  {
    position: 'DA',
    specialty: 'Surgical',
    display: 'Oral Surgery Assistant',
    url: 'oral-surgery-assistant',
    synonyms: '',
    searchterms: '',
  },
  {
    position: 'DA',
    specialty: 'Orthodontic',
    display: 'Orthodontic Assistant',
    url: 'orthodontic-assistant',
    synonyms: '',
    searchterms: 'ortho',
  },
  {
    position: 'DD',
    specialty: 'Orthodontic',
    display: 'Orthodontist',
    url: 'orthodontist',
    synonyms: '',
    searchterms: 'ortho, Orthodontic, orthodontist',
  },
  {
    position: 'DA',
    specialty: 'Pediatric',
    display: 'Pediatric Dental Assistant',
    url: 'pediatric-dental-assistant',
    synonyms: '',
    searchterms: 'ped, pedo',
  },
  {
    position: 'DD',
    specialty: 'Pediatric',
    display: 'Pediatric Dentist',
    url: 'pediatric-dentist',
    synonyms: '',
    searchterms: 'ped, pedo',
  },
  {
    position: 'DD',
    specialty: 'Periodontal',
    display: 'Periodontist',
    url: 'periodontist',
    synonyms: '',
    searchterms: 'perio',
  },
  {
    position: 'DA',
    specialty: 'Prosthodontic',
    display: 'Prosthodontic Dental Assistant',
    url: 'prosthodontic-dental-assistant',
    synonyms: '',
    searchterms: 'pros, prosthodontal',
  },
  {
    position: 'DD',
    specialty: 'Prosthodontic',
    display: 'Prosthodontist',
    synonyms: '',
    url: 'prosthodontist',
    searchterms: 'pros, prosthodontal',
  },
];
